import styled from 'styled-components';

export const RolesCell = styled.div`
  padding: 6px;
  background: var(--color-surface-muted);
  color: var(--color-text-muted);
  font-weight: 500;
  font-size: 12px;
  line-height: 90%;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  margin: 0 10px 10px 0;

  svg {
    cursor: pointer;
  }
`;
